var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "ci-registration-form d-flex w-100",
      class: { "on-page": !_vm.inModalContext },
    },
    [
      _c(
        "div",
        {
          staticClass: "ci-card w-100 overflow-hidden mb-0",
          attrs: { "no-body": "" },
        },
        [
          _c(
            "div",
            { staticClass: "row h-100 registration-form__content no-gutters" },
            [
              _vm.userIsRegistered
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "col-auto col-lg-7 p-3 p-md-4 flex-center",
                      },
                      [
                        _c("ci-confirm-email", {
                          attrs: {
                            "in-modal-context": _vm.inModalContext,
                            "return-button-text": _vm.backLinkText,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-auto col-lg-7 p-3 p-md-4 flex-grow-1 d-md-flex justify-content-center align-items-center",
                      },
                      [
                        _c("div", { staticClass: "registration-form-width" }, [
                          _c("div", { staticClass: "registration-headline" }, [
                            _c("h1", {
                              staticClass: "registration-form__headline",
                              class: [
                                _vm.inModalContext
                                  ? "registration-form__headline--is-modal"
                                  : null,
                              ],
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "ui.components.users.onboarding.register.register_information"
                                  )
                                ),
                              },
                            }),
                            _c("p", {
                              staticClass: "registration-form__sub-headline",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "ui.components.users.onboarding.register.subheadline"
                                  )
                                ),
                              },
                            }),
                            _c("p", {
                              staticClass: "registration-form__sub-headline",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "ui.components.users.onboarding.register.alternative_locales"
                                  )
                                ),
                              },
                            }),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "registration registration-form__inner vh-70",
                            },
                            [
                              _c("ci-omniauth-buttons", {
                                staticClass: "my-3",
                                attrs: {
                                  providers: _vm.providers,
                                  "onboarding-type": _vm.onboardingType,
                                  "gating-banner-location":
                                    _vm.gatingBannerLocation,
                                  "authenticity-token":
                                    _vm.$settings.options.registration.omniauth
                                      .form_authenticity_token,
                                },
                              }),
                              _c("validation-observer", {
                                attrs: { tag: "div" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (validator) {
                                      return [
                                        _c(
                                          "form",
                                          {
                                            attrs: { id: "registration-form" },
                                            on: {
                                              submit: function ($event) {
                                                $event.preventDefault()
                                                return _vm.submit.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                { staticClass: "col-12" },
                                                [
                                                  _c("ci-input", {
                                                    attrs: {
                                                      "input-id": "user_email",
                                                      label: `${_vm.$t(
                                                        "ui.shared.global.email"
                                                      )}*`,
                                                      "human-name": _vm.$t(
                                                        "ui.shared.global.email"
                                                      ),
                                                      rules: { required: true },
                                                    },
                                                    model: {
                                                      value: _vm.email,
                                                      callback: function ($$v) {
                                                        _vm.email = $$v
                                                      },
                                                      expression: "email",
                                                    },
                                                  }),
                                                  _vm.errors && _vm.errors.email
                                                    ? _c("span", {
                                                        staticClass:
                                                          "text-danger",
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.errors.email[0]
                                                          ),
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]),
                                            _c(
                                              "div",
                                              { staticClass: "row mt-3" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-12" },
                                                  [
                                                    _c("ci-password-input", {
                                                      attrs: {
                                                        "input-id":
                                                          "user_password",
                                                        label: `${_vm.$t(
                                                          "ui.shared.global.password"
                                                        )}*`,
                                                        "human-name": _vm.$t(
                                                          "ui.shared.global.password"
                                                        ),
                                                        "validation-messages": {
                                                          required: _vm.$t(
                                                            "user.edit.password.input_new_pw"
                                                          ),
                                                          min: _vm.$t(
                                                            "user.edit.password.too_short"
                                                          ),
                                                        },
                                                        rules: {
                                                          required: true,
                                                          min: 8,
                                                        },
                                                        hint: "ui.components.base.forms.password_input.length",
                                                        "show-requirements":
                                                          "true",
                                                      },
                                                      model: {
                                                        value: _vm.password,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.password = $$v
                                                        },
                                                        expression: "password",
                                                      },
                                                    }),
                                                    _vm.errors &&
                                                    _vm.errors.password
                                                      ? _c("span", {
                                                          staticClass:
                                                            "text-danger",
                                                          domProps: {
                                                            textContent: _vm._s(
                                                              _vm.errors
                                                                .password[0]
                                                            ),
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.middleName,
                                                  expression: "middleName",
                                                },
                                              ],
                                              staticClass: "honeypot-input",
                                              attrs: {
                                                id: "user_middlename",
                                                type: "hidden",
                                                name: "middlename",
                                                autocomplete: "off",
                                                tabindex: "-1",
                                              },
                                              domProps: {
                                                value: _vm.middleName,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.middleName =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.invisibleCaptchaSpinner,
                                                  expression:
                                                    "invisibleCaptchaSpinner",
                                                },
                                              ],
                                              attrs: {
                                                id: "invisible_captcha_spinner",
                                                name: "invisible_captcha_spinner",
                                                type: "hidden",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.invisibleCaptchaSpinner,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.invisibleCaptchaSpinner =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _c("ci-checkbox", {
                                              staticClass: "mt-3",
                                              attrs: {
                                                name: "accept_latest_tos_version",
                                                label: _vm.$t(
                                                  "ui.components.users.onboarding.register.accept_tos_html"
                                                ),
                                                "show-asteriks": false,
                                                rules: { required: true },
                                                vCenter: true,
                                              },
                                              model: {
                                                value:
                                                  _vm.acceptLatestTosVersion,
                                                callback: function ($$v) {
                                                  _vm.acceptLatestTosVersion =
                                                    $$v
                                                },
                                                expression:
                                                  "acceptLatestTosVersion",
                                              },
                                            }),
                                            _c("ci-checkbox", {
                                              staticClass: "mt-3",
                                              attrs: {
                                                name: "accept_latest_privacy_version",
                                                label: _vm.$t(
                                                  "ui.components.users.onboarding.register.accept_privacy_html"
                                                ),
                                                "show-asteriks": false,
                                                rules: { required: true },
                                                vCenter: true,
                                              },
                                              model: {
                                                value:
                                                  _vm.acceptLatestPrivacyVersion,
                                                callback: function ($$v) {
                                                  _vm.acceptLatestPrivacyVersion =
                                                    $$v
                                                },
                                                expression:
                                                  "acceptLatestPrivacyVersion",
                                              },
                                            }),
                                            _c("ci-button", {
                                              staticClass:
                                                "w-100 mt-5 registration-form__submit-button",
                                              attrs: {
                                                id: "registration-submit",
                                                variant: "filled-primary",
                                                type: "submit",
                                                disabled:
                                                  _vm.isDisabled ||
                                                  validator.invalid,
                                                label: _vm.$t(
                                                  "ui.shared.global.register_now"
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "registration-form__redirect-link",
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "ui.components.users.onboarding.register.already_registered"
                                        )
                                      ),
                                    },
                                  }),
                                  _c("a", {
                                    staticClass:
                                      "registration-form__redirect-link-inner",
                                    attrs: { id: "login-modal-link" },
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "ui.components.users.onboarding.register.login_now"
                                        )
                                      ),
                                    },
                                    on: { click: _vm.openLoginModal },
                                  }),
                                ]
                              ),
                              _vm.partnersEnabled
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "partner-logins py-5 pb-md-3",
                                    },
                                    [
                                      _c("ci-partner-buttons", {
                                        attrs: {
                                          "onboarding-type": _vm.onboardingType,
                                          "gating-banner-location":
                                            _vm.gatingBannerLocation,
                                          "authenticity-token":
                                            _vm.$settings.options.registration
                                              .omniauth.form_authenticity_token,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("div", {
                                    staticClass:
                                      "partner-placeholder pb-5 pb-md-3",
                                  }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ],
              _c(
                "div",
                {
                  staticClass:
                    "col-auto col-lg-5 bg-primary text-white p-3 p-md-4 d-flex justify-content-center align-items-center w-100",
                },
                [
                  _c("ci-information-content", {
                    attrs: { "in-modal-context": _vm.inModalContext },
                  }),
                ],
                1
              ),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }